import {
  AlignmentType,
  Footer,
  Header,
  ImageRun,
  Paragraph,
  TextRun,
} from "docx";
import { toribio_achaval_patagonia_header } from "../docImages/toribio_achaval_patagonia";

export const styles_toribio_langostura = {
  companyId: ["12450"],
  companyName: "Toribio Achával Langostura",
  font: "Arial",
  titleSize: 22,
  textSize: 22,
  lineSpacing: 300,
  marginRight: 1500,
  marginLeft: 1500,
  beforeParagraph: 300,

  header: new Header({
    children: [
      new Paragraph({
        spacing: {
          before: 0,
          after: 550,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new ImageRun({
            data: toribio_achaval_patagonia_header,
            transformation: {
              width: 220,
              height: 60,
            },
          }),
        ],
      }),
    ],
  }),

  footer: new Footer({
    children: [
      new Paragraph({
        spacing: {
          before: 60,
          after: 60,
        },
        alignment: AlignmentType.CENTER,
        children: [
          new TextRun({
            text: "Toribioachaval.com		Cerro Inacayal 104. Villa la Angostura, CP 8407. Neuquen",
            size: 22,
            font: "Arial",
          }),
        ],
      }),
    ],
  }),
};
